import { create } from "zustand"

import type { User } from "@/graphql/codegen/graphql"

// Define Zustand store
interface AccountManagerState {
  visibleManagers: User[]
  limit: number
  setVisibleManagers: (managers: User[]) => void
}

export const useAccountManagerStore = create<AccountManagerState>((set) => ({
  visibleManagers: [],
  limit: 100,
  setVisibleManagers: (managers) => set({ visibleManagers: managers }),
}))
